module.exports = __webpack_public_path__ + "bin/4ef30b814ebc3c9352d991dc56ceaa4f.jpg";